import { Box, Stack, Typography, List, ListItem, Alert } from "@mui/material";
import { FC, useEffect } from "react";
import StringArrayTextField from "@/components/input/StringArrayTextField";
import { useZSliceUnderContext } from "@/utils/zustand-form/hooks";
import { FormToken } from "@/utils/zustand-form/types";
import { EditorLineSx } from './InfoTypeEditor.types';
import { CollectEditsMetadata, CollectEditsProtocol } from "@/utils/zustand-form/ext/collectEdits";

const DenyListEditor : FC<{
  parentToken?: FormToken,
  baseData: string[],
}> = ({parentToken, baseData}) => {
  const utils = useZSliceUnderContext({
    parentToken: parentToken ?? null,
    pathFragment: 'denyList',
    prevData: baseData,
    stageInit: () => baseData ?? [],
    extraStates: {},
  });
  const { states, setStates, installProtocolMetadata } = utils;

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setStates(v => ({...v, prevData: baseData, stage: [...baseData] as any, touched: {} as any}))
  }, [baseData, setStates])
  useEffect(() => {
    return installProtocolMetadata<CollectEditsMetadata>(CollectEditsProtocol.metadataKey, {
      triggerValidate: () => Promise.resolve(),
      overrideCollect: async (node) => node.state.stage,
    })
  }, [installProtocolMetadata])

  return (
    <Box
      sx={EditorLineSx}
    >
      <Stack direction="row" marginBottom={1}>
        <Typography variant="subtitle2">Keyword Detection</Typography>
      </Stack>
      <Alert severity="info" sx={{ mb: 1}}>
        Any one of these keywords found (case insensitive) will be categorized as this Info Type.
      </Alert>
      <List disablePadding>
        <ListItem className={Object.keys(states.touched).length > 0 ? 'dirty' : undefined}>
          <StringArrayTextField list={states.stage} stackChips="row"
            setList={(ls) => setStates(v => {
              const stage = [...new Set(ls)]
              const dirty = !(v.prevData.length === stage.length && v.prevData.every(s => stage.indexOf(s) > -1))
              // Type assertion needed - see comment in useEffect above
              return {...v, stage, touched: dirty ? { ls: true } : {}} as any
            })}
            placeholder="Add a new value (case insensitive) and press the Enter key to confirm..."
          />
        </ListItem>
      </List>
    </Box>
  )
}

export default DenyListEditor;
